import i18n from 'translations/i18next';

export const useI18n = () => i18n;
